import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { SRLWrapper } from 'simple-react-lightbox';
import { getGalleriesHousingMaterials } from '../../aboutIsn.api';
import { useLocation } from 'react-router';
import { getLanguage, getQueryString } from 'utils/params';
import useFullPageLoader from '../../../commons/isn/useFullPageLoader';

const MaterialGalleryContent = () => {
    const { t } = useTranslation();
    const [galleries, setGalleries] = useState([]);
    const language = getLanguage(useLocation());
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const options = {
        settings: {
            disableWheelControls: true,
        },

        buttons: {
            backgroundColor: 'rgba(30,30,36,0.8)',
            iconColor: 'rgba(255, 255, 255, 0.8)',
            iconPadding: '10px',
            showAutoplayButton: false,
            showCloseButton: true,
            showDownloadButton: false,
            showFullscreenButton: false,
            showNextButton: true,
            showPrevButton: true,
            showThumbnailsButton: false,
            size: '43px',
        },

        thumbnails: {
            showThumbnails: false,
        },
    };

    useEffect(() => {
        showLoader();
        getGalleriesHousingMaterials(getQueryString({ language })).then(res => {
            setGalleries(res ?? []);
            hideLoader();
        });
        //eslint-disable-next-line
    }, []);

    return (
        <>
            <div id="housingMaterialGallery">
                <div className="row">
                    <div className="col-12">
                        <p className="title text-uppercase">
                            {t("about_isn.housing_material.lbl_gallery")}
                        </p>
                        <SRLWrapper options={options}>
                            <div className="row text-center">
                                {galleries.length > 0 && galleries?.map((item, index) => {
                                    return (
                                        <div className="col-12 col-sm-4 mt-4" key={index}>
                                            <LazyLoadImage
                                                alt={`image${index}`}
                                                src={`${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl}`}
                                                effect="blur"
                                                className="w-100 h-100 image-lg"
                                            />
                                        </div>
                                    );
                                })}
                            </div>
                        </SRLWrapper>
                    </div>
                </div>
            </div>
            {loader}
        </>
    )
}
export default MaterialGalleryContent;